module.exports = __webpack_public_path__ + "img/Flag_of_the_United_States (1).be0d3dd8.svg";